import React from "react";
import StyledUnorderedList from "./UnorderedList.styled";

const IndustryKnowledgeList = () => (
    <StyledUnorderedList>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Content &amp; Database Management</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Web Development &amp; Design</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Process Improvement &amp; Reengineering</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Customer Service &amp; Incident Tracking</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Application Development &amp; Support</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">ETL Data Pipelines</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Legal &amp; Compliance Research</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Customer Engagement</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Digital Video</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Technology Strategy &amp; Assessment</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Cloud</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Low Code/No Code</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Networking</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Data Warehousing</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Business Intelligence</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Machine Learning</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">LAMP Stack</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">JAM Stack</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">DevOps</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group no-bottom-border">
            <div className="list-item">
                <div className="text">NoSql</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
    </StyledUnorderedList>
);

export default IndustryKnowledgeList;